module.exports = __webpack_public_path__ + "img/horst.053f2922.jpg";